<script>
export default {
    props: {
        validation: {
            type: Object,
            required: false,
        }
    },
    computed: {
        internalErrorMessages() {
            if (this.validation && this.validation.$error) {

                if (this.validation.$params) {
                    return this.buildLegacy(this.validation);
                }

                if (this.validation.$errors) {
                    return this.validation.$errors.map(error => {
                        return error.$message;
                    });
                }
            }

            return [];
        }
    },
    methods: {
        buildLegacy(validation) {
            let messages = [];
            if (!validation.required && validation.$params.required) {
                messages.push((this.label ? this.label : 'Dit veld') + ' is verplicht');
            }
            if (!validation.email && validation.$params.email) {
                messages.push((this.label ? this.label : 'Dit veld') + ' moet een geldig mailadres zijn');
            }
            if (!validation.required_without_all && validation.$params.required_without_all) {
                messages.push((this.label ? this.label : 'Dit veld') + ' is verplicht');
            }
            if (!validation.decimal && validation.$params.decimal) {
                messages.push((this.label ? this.label : 'Dit veld') + ' moet een decimaal getal zijn.');
            }
            if (!validation.minLength && validation.$params.minLength) {
                messages.push((this.label ? this.label : 'Dit veld') + '  moet minimaal ' + validation.$params.minLength.min + ' karakters zijn');
            }
            if (!validation.maxLength && validation.$params.maxLength) {
                messages.push((this.label ? this.label : 'Dit veld') + '  mag maximaal ' + validation.$params.maxLength.max + ' karakters zijn');
            }
            if (!validation.between && validation.$params.between) {
                messages.push((this.label ? this.label : 'Dit veld') + ' moet tussen de ' + validation.$params.between.min + ' en ' + validation.$params.between.max + ' liggen');
            }
            if (!validation.beforeDate && validation.$params.beforeDate) {
                messages.push('De datum moet voor ' + validation.$params.beforeDate.value + ' zijn');
            }
            if (!validation.afterDate && validation.$params.afterDate) {
                messages.push('De datum moet na ' + validation.$params.afterDate.value + ' zijn');
            }
            if (!validation.afterOrEqualDate && validation.$params.afterOrEqualDate) {
                messages.push('De datum moet eerder of gelijk aan ' + validation.$params.afterOrEqualDate.value + ' zijn');
            }
            if (!validation.beforeOrEqualDate && validation.$params.beforeOrEqualDate) {
                messages.push('De datum moet later of gelijk aan ' + validation.$params.beforeOrEqualDate.value + ' zijn');
            }
            if (!validation.phoneNumber && validation.$params.phoneNumber) {
                messages.push((this.label ? this.label : 'Dit veld') + ' is geen correct telefoonnummer');
            }
            if (!validation.url && validation.$params.url) {
                messages.push((this.label ? this.label : 'Dit veld') + ' is geen juiste url');
            }
            if (!validation.minValue && validation.$params.minValue) {
                messages.push((this.label ? this.label : 'Dit veld')  +'  moet minimaal ' + validation.$params.minValue.min+ ' zijn');
            }
            if (!validation.maxValue && validation.$params.maxValue) {
                messages.push((this.label ? this.label : 'Dit veld')  +'  moet maximaal ' + validation.$params.maxValue.max+ ' zijn');
            }
            if ('isDateTime' in validation && !validation.isDateTime) {
                messages.push('Verkeerde waarde (DD-MM-YYYY HH:MM:SS)');
            }
            if ('isDateTimeWithoutSeconds' in validation && !validation.isDateTimeWithoutSeconds) {
                messages.push('Verkeerde waarde (DD-MM-YYYY HH:MM)');
            }
            if ('isTime' in validation && !validation.isTime) {
                messages.push('Verkeerde waarde (HH:MM)');
            }
            if ('validBirthDate' in validation && !validation.validBirthDate) {
                messages.push('De geboortedatum moet tussen nu en 100 jaar geleden liggen');
            }

            return messages;
        }
    }
}
</script>
